export const SET_ALERT_OPEN = 'SET_ALERT_OPEN';
export const SET_MOB_SIDE_NAV_BAR_VISIBILITY =
  'SET_MOB_SIDE_NAV_BAR_VISIBILITY';
export const SET_FILTERS_VISIBILITY = 'SET_FILTERS_VISIBILITY';
export const SET_THEME = 'SET_THEME';
